import { render, staticRenderFns } from "./penaltyPaidData.vue?vue&type=template&id=3d29b602&"
import script from "./penaltyPaidData.vue?vue&type=script&lang=js&"
export * from "./penaltyPaidData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports